<div class="flex min-h-screen bg-[#F3F4F6] font-sans">
  <aside class="w-64 bg-[#5b21b6] text-white flex flex-col shrink-0 fixed h-full z-10 print:hidden">
    <div class="p-6 flex items-center gap-3">
      <app-logo></app-logo>
    </div>
    <nav class="flex-1 px-4 space-y-2 mt-4">
      <a routerLink="/intake"
         class="flex items-center gap-3 px-4 py-3 text-white/80 hover:bg-white/10 rounded-lg font-medium transition-colors">
        <span class="material-icons text-xl">dashboard</span> Dashboard
      </a>
      <div class="my-2 border-l-4 border-white ml-[-16px] pl-[12px]">
        <span
              class="flex items-center gap-3 px-4 py-3 bg-white text-brand-purple rounded-lg font-medium shadow-sm w-full">
          <span class="material-icons text-xl">assessment</span> View Report
        </span>
      </div>
    </nav>

    <div class="p-4 border-t border-white/10 mt-auto">
      <button (click)="logout()"
              class="flex items-center gap-3 px-4 py-3 text-white/80 hover:bg-white/10 rounded-lg font-medium transition-colors w-full">
        <span class="material-icons text-xl">logout</span> Sign Out
      </button>
    </div>
  </aside>

  <main class="flex-1 p-8 ml-64 overflow-y-auto print:m-0 print:p-0 print:w-full">
    <header class="hidden print:block mb-6 border-b-2 border-gray-800 pb-2">
      <div class="flex items-center justify-between">
        <div>
          <h1 class="text-2xl font-bold text-gray-900">Organization Name Here</h1>
          <p class="text-xs text-gray-600 mt-1">
            Official health application report for <span class="font-bold">{{ targetUser?.firstName }} {{
              targetUser?.lastName
              }}</span>
          </p>
        </div>
        <div
             class="flex flex-col items-center justify-center border border-dashed border-gray-400 p-2 rounded bg-white h-16 w-40">
          <span class="text-xs font-bold text-gray-500 uppercase">Logo Here</span>
        </div>
      </div>
    </header>

    <header class="flex justify-between items-center mb-8 no-print">
      <div>
        <h1 class="text-2xl font-bold text-gray-900">Application Report</h1>
        <p class="text-sm text-gray-500 mt-1">
          Reviewing details for <span class="font-bold text-brand-purple">{{ targetUser?.firstName }} {{
            targetUser?.lastName }}</span>
        </p>
      </div>
      <div class="flex gap-3">
        <button (click)="navigateToEdit()"
                [disabled]="!canEdit"
                [class.opacity-50]="!canEdit"
                [class.cursor-not-allowed]="!canEdit"
                [title]="!canEdit ? 'Application status does not allow editing.' : 'Edit Application'"
                class="flex items-center gap-2 px-5 py-2.5 bg-white border border-gray-300 text-gray-700 font-bold rounded-xl hover:bg-gray-50 shadow-sm transition-all">
          <span class="material-icons text-lg">edit</span> Edit Application
        </button>
        <button (click)="printReport()"
                class="flex items-center gap-2 px-5 py-2.5 bg-[#8b5cf6] text-white font-bold rounded-xl hover:bg-purple-700 shadow-lg shadow-purple-200 transition-all">
          <span class="material-icons text-lg">print</span> Print / Save PDF
        </button>
        <app-user-profile-avatar></app-user-profile-avatar>
      </div>
    </header>

    @if (isLoading()) {
    <div class="bg-white p-12 rounded-xl shadow-sm"><nz-skeleton [nzActive]="true"></nz-skeleton></div>
    } @else if (reportData) {

    <div class="max-w-5xl mx-auto space-y-6 print:space-y-4 text-gray-800 print:text-sm">

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100 print-card">
        <div
             class="flex justify-between items-start border-b border-gray-100 pb-4 mb-4 print:pb-2 print:mb-2 print:border-gray-300">
          <div class="flex items-center gap-3">
            <h2 class="text-xl font-bold text-gray-900 print:text-lg">Application Summary</h2>
          </div>
          <div class="text-right">
            <span class="block text-xs font-bold text-gray-500 uppercase">Application ID</span>
            <span class="text-sm font-mono text-gray-900 print:text-xs">{{ reportData.id }}</span>
          </div>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-6 print:gap-4 print:grid-cols-4">
          <div>
            <span class="block text-xs font-bold text-gray-500 uppercase mb-1">Status</span>
            <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 print:bg-transparent print:text-black print:p-0 print:border print:border-gray-300 print:px-2">
              {{ reportData.status }}
            </span>
          </div>
          <div>
            <span class="block text-xs font-bold text-gray-500 uppercase mb-1">Date Submitted</span>
            @if(reportData.submittedDate ?? reportData.updatedDate ?? reportData.createdDate) {
            <span class="text-sm font-medium">{{ (reportData.submittedDate ?? reportData.updatedDate ??
              reportData.createdDate) | date:'mediumDate' }}</span>
            } @else {
            <span class="text-sm font-medium text-gray-400 italic"> </span>
            }
          </div>
          <div>
            <span class="block text-xs font-bold text-gray-500 uppercase mb-1">Type</span>
            <span class="text-sm font-medium">{{ reportData.type }}</span>
          </div>
          <div>
            <span class="block text-xs font-bold text-gray-500 uppercase mb-1">Zip Code</span>
            <span class="text-sm font-medium">{{ reportData.zipcode }}</span>
          </div>

          @if(reportData.peNumber) {
          <div
               class="col-span-2 md:col-span-1 border-l-4 border-brand-purple pl-3 bg-purple-50 rounded-r print:bg-white print:border-l-2 print:border-black print:pl-2">
            <span class="block text-xs font-bold text-gray-500 uppercase mb-1">PE Number</span>
            <span class="text-base font-mono font-bold text-gray-900 print:text-sm">{{ reportData.peNumber }}</span>
          </div>
          }
        </div>

        @if(reportData.updateRequestNotes && reportData.updateRequestNotes !== 'null' && reportData.updateRequestNotes
        !== '-') {
        <div class="mt-6 pt-4 border-t border-gray-100 print:mt-4 print:pt-2">
          <span class="block text-xs font-bold text-gray-500 uppercase mb-2">Intake Notes (Required Actions)</span>
          <div
               class="p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-sm text-gray-800 font-medium print:bg-transparent print:border print:border-gray-300 print:p-1 print:text-xs">
            {{ reportData.updateRequestNotes }}
          </div>
        </div>
        }
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100 print-card avoid-break">
        <h3
            class="text-lg font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 print:mb-2 print:text-base print:border-gray-300">
          Household Members</h3>

        <div class="overflow-x-auto">
          <table class="w-full text-left text-sm print:text-xs">
            <thead class="bg-gray-50 text-gray-600 font-bold uppercase text-xs print:bg-gray-100">
              <tr>
                <th class="px-4 py-3 rounded-l-lg print:px-2 print:py-1">Name</th>
                <th class="px-4 py-3 print:px-2 print:py-1">Role</th>
                <th class="px-4 py-3 print:px-2 print:py-1">DOB / Gender</th>
                <th class="px-4 py-3 print:px-2 print:py-1">SSN (Masked)</th>
                <th class="px-4 py-3 print:px-2 print:py-1">Status</th>
                <th class="px-4 py-3 rounded-r-lg print:px-2 print:py-1">Student</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              @for(member of reportData.members; track member.index) {
              <tr class="print:border-b print:border-gray-200">
                <td class="px-4 py-3 font-medium text-gray-900 print:px-2 print:py-1">{{ member.name }}</td>
                <td class="px-4 py-3 text-gray-600 print:px-2 print:py-1">{{ member.role }}</td>
                <td class="px-4 py-3 text-gray-600 print:px-2 print:py-1">
                  {{ member.dob }} <span class="text-gray-400">|</span> {{ member.gender }}
                </td>
                <td class="px-4 py-3 text-gray-600 font-mono print:px-2 print:py-1">
                  {{ member.ssn }}
                </td>
                <td class="px-4 py-3 text-gray-600 text-xs print:px-2 print:py-1">{{ member.citizenship }} | {{
                  member.marital }}</td>
                <td class="px-4 py-3 text-gray-600 print:px-2 print:py-1">{{ member.student }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 print:grid-cols-2 print:gap-4">

        <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100 print-card avoid-break">
          <h3
              class="text-lg font-bold text-gray-900 mb-4 border-b border-gray-100 pb-2 flex items-center gap-2 print:text-base print:mb-2 print:border-gray-300">
            <span class="material-icons text-brand-purple text-base print:hidden">home</span> Contact Information
          </h3>

          <div class="space-y-4 print:space-y-2">
            <div>
              <p class="text-xs font-bold text-gray-500 uppercase">Home Address</p>
              <p class="text-sm font-medium print:text-xs">{{ reportData.homeAddress.street1 }} {{
                reportData.homeAddress.street2 }}
              </p>
              <p class="text-sm text-gray-600 print:text-xs">{{ reportData.homeAddress.city }}, {{
                reportData.homeAddress.state }} {{
                reportData.homeAddress.zip }}</p>
            </div>

            <div>
              <p class="text-xs font-bold text-gray-500 uppercase">Mailing Address</p>
              @if(reportData.mailingSameAsHome) {
              <p class="text-sm text-gray-500 italic print:text-xs">Same as Home Address</p>
              } @else {
              <p class="text-sm font-medium print:text-xs">{{ reportData.mailingAddress.street1 }} {{
                reportData.mailingAddress.street2 }}</p>
              <p class="text-sm text-gray-600 print:text-xs">{{ reportData.mailingAddress.city }}, {{
                reportData.mailingAddress.state
                }} {{ reportData.mailingAddress.zip }}</p>
              }
            </div>

            <div class="pt-2 border-t border-gray-100 grid grid-cols-2 gap-4 print:pt-1 print:gap-2">
              <div>
                <p class="text-xs font-bold text-gray-500 uppercase">Phone</p>
                <p class="text-sm print:text-xs">{{ reportData.contact.primaryPhone }} <span
                        class="text-xs text-gray-400">({{
                    reportData.contact.primaryType }})</span></p>
              </div>
              <div>
                <p class="text-xs font-bold text-gray-500 uppercase">Email</p>
                <p class="text-sm break-all print:text-xs">{{ reportData.contact.email }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100 print-card avoid-break">
          <h3
              class="text-lg font-bold text-gray-900 mb-4 border-b border-gray-100 pb-2 flex items-center gap-2 print:text-base print:mb-2 print:border-gray-300">
            <span class="material-icons text-brand-purple text-base print:hidden">attach_money</span> Financial Details
          </h3>

          <div class="space-y-4 print:space-y-2">
            <div class="flex justify-between">
              <span class="text-sm text-gray-600 print:text-xs">Gross Annual Income</span>
              <span class="text-sm font-bold text-gray-900 print:text-xs">${{ reportData.financial.grossAnnual }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-sm text-gray-600 print:text-xs">Monthly (Calculated)</span>
              <span class="text-sm font-bold text-gray-900 print:text-xs">${{ reportData.financial.monthlyCalculated
                }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-sm text-gray-600 print:text-xs">Household Assets</span>
              <span class="text-sm font-bold text-gray-900 print:text-xs">${{ reportData.financial.assets }}</span>
            </div>

            <div class="border-t border-gray-100 pt-3 mt-2 print:pt-2 print:mt-1">
              <div class="flex justify-between mb-2">
                <span class="text-sm text-gray-600 print:text-xs">Tax Filing Status</span>
                <span class="text-sm font-medium text-right print:text-xs">{{ reportData.financial.filingStatus
                  }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-sm text-gray-600 print:text-xs">Weekly Work Hours</span>
                <span class="text-sm font-medium print:text-xs">{{ reportData.financial.workHours }} hrs</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100 print-card">
        <h3
            class="text-lg font-bold text-gray-900 mb-6 border-b border-gray-100 pb-2 print:mb-3 print:text-base print:border-gray-300">
          Health & Life Events</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 print:grid-cols-1 print:gap-4">
          <div class="print:w-full">
            <h4 class="text-xs font-bold text-gray-500 uppercase mb-3 print:mb-1">Health Questionnaire</h4>
            <ul class="space-y-2 print:space-y-0 print:grid print:grid-cols-3 print:gap-x-4 print:gap-y-1">
              @for(q of reportData.healthQuestions; track q.label) {
              <li
                  class="flex items-center justify-between text-sm py-1 border-b border-gray-50 last:border-0 print:border-b-0 print:py-0 print:text-xs">
                <span class="text-gray-700 truncate pr-2">{{ q.label }}</span>
                @if(q.value) {
                <span
                      class="flex items-center gap-1 text-green-700 font-bold bg-green-50 px-2 py-0.5 rounded-full print:bg-transparent print:border print:border-black print:px-1 print:py-0 print:text-[10px] print:h-5">
                  <span class="material-icons text-sm print:hidden">check</span> YES
                </span>
                } @else {
                <span class="text-gray-400 print:text-gray-800 font-mono print:text-[10px]">No</span>
                }
              </li>
              }
            </ul>
          </div>

          <div
               class="space-y-6 print:space-y-0 print:grid print:grid-cols-3 print:gap-4 print:mt-4 print:border-t print:pt-4 print:border-gray-200">
            <div class="avoid-break">
              <h4 class="text-xs font-bold text-gray-500 uppercase mb-2 print:mb-1">Qualifying Life Event</h4>
              <div
                   class="p-3 bg-purple-50 rounded-lg text-brand-purple font-medium border border-purple-100 print:bg-white print:text-black print:border print:border-gray-300 print:p-1 print:text-xs">
                {{ reportData.qualifyingEvent }}
              </div>
            </div>

            <div class="avoid-break">
              <h4 class="text-xs font-bold text-gray-500 uppercase mb-2 print:mb-1">Selected Conditions</h4>
              <div
                   class="p-3 bg-red-50 rounded-lg text-red-800 font-medium border border-red-100 print:bg-white print:text-black print:border print:border-gray-300 print:p-1 print:text-xs">
                {{ reportData.conditions }}
              </div>
            </div>

            <div class="pt-4 border-t border-gray-100 print:border-0 print:pt-0 avoid-break">
              <h4 class="text-xs font-bold text-gray-500 uppercase mb-2 print:mb-1">Coverage Status</h4>
              <div class="flex flex-col gap-2 text-sm print:text-xs print:gap-1">
                <div class="flex justify-between">
                  <span>Has Insurance?</span>
                  <span class="font-bold">{{ reportData.coverage.hasInsurance ? 'Yes' : 'No' }}</span>
                </div>
                <div class="flex justify-between">
                  <span>Has Medicare?</span>
                  <span class="font-bold">{{ reportData.coverage.hasMedicare ? 'Yes' : 'No' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100 print-card break-inside-avoid">
        <h3
            class="text-lg font-bold text-gray-900 mb-4 border-b border-gray-100 pb-2 print:text-base print:mb-2 print:border-gray-300">
          Attestation & Signature</h3>

        <div
             class="bg-gray-50 p-4 rounded-lg text-sm text-gray-600 mb-6 italic border border-gray-200 print:bg-white print:text-xs print:border-none print:p-0 print:mb-2">
          "I have read and agree to the above statements. Under penalty of perjury, I certify that the information
          provided is true and correct. I understand that providing false information may result in denial of benefits."
          <div class="mt-2 font-bold text-gray-800 flex items-center gap-2 print:mt-1">
            <span class="material-icons text-green-600 print:text-sm">check_circle</span> Attestation Agreed
          </div>
        </div>

        <div class="grid grid-cols-2 gap-8 items-end print:gap-4">
          <div>
            <p class="text-xs font-bold text-gray-500 uppercase mb-2 print:mb-0">Electronic Signature</p>
            <div class="h-16 border-b-2 border-gray-800 flex items-end pb-2 print:h-10">
              <span class="signature-font text-3xl text-brand-purple print:text-black print:text-xl">
                {{ reportData.attestation.signature }}
              </span>
            </div>
          </div>
          <div>
            <p class="text-xs font-bold text-gray-500 uppercase mb-2 print:mb-0">Date Signed</p>
            <div class="h-16 border-b-2 border-gray-800 flex items-end pb-2 print:h-10">
              <span class="text-lg font-mono text-gray-900 print:text-sm">
                {{ reportData.attestation.date }}
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
    } @else {
    <div class="text-center py-12">
      <h3 class="text-lg font-medium text-gray-900">No application data available.</h3>
      <button (click)="backToDashboard()"
              class="mt-4 text-brand-purple hover:underline">Return to Dashboard</button>
    </div>
    }
  </main>
</div>